import React from "react";
import "./_index.scss";
import Pagination from "../../../Components/Pagination";

const MAX_LENGTH = 1000;
const ELLIPSIS = '...';

export default class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        paginationMaxButtonCount: 5,
      }
    }

    _onResize = () => {
      const LAEGE_DEVICE_WIDTH = 992;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      
      this.setState({
        paginationMaxButtonCount: viewportWidth >= LAEGE_DEVICE_WIDTH ? 10 : 5 
      })
    }

    componentDidMount() {
      window.addEventListener('resize', this._onResize);
      this._onResize();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this._onResize);
    }

    _generateBusyEffect() {
        return (
            <div className="dn-search-result-busy">
                <div className="dn-search-result-busy-bounce1"></div>
                <div className="dn-search-result-busy-bounce2"></div>
                <div className="dn-search-result-busy-bounce3"></div>
            </div>
        );
    }

    _generateNoContent() {
        return (
            <div className='dn-search-result-no-content'>
                No content
            </div>
        );
    }

    _generateItem = (ri, index) => {
        const item = ri.source;
        const ITEM_TYPE_MAP = {
            "PubHubSiteContent": "Site",
            "PubHubDocContent": "Doc"
        }

        const searchKey = this.props.searchKey.replace(/\+/g, '');
        const itemType = ITEM_TYPE_MAP[item.type] || item.type;

        const activedTab = this.props.activedType.replace(/ /g, '') || 'All';
        const trackName = `search:${activedTab}`;
        const url = (item.type || '').toUpperCase() == 'CODE' ? `/codeexchange/github/repo/${item.name}` : item.url;

        return (
            <div className='dn-search-result-item' key={item.id}>
                <a className='dn-search-result-item-name' href={url} target='_blank'
                    data-track-name={trackName} data-track-value={url}
                    dangerouslySetInnerHTML={{"__html": this._getName(ri)}}>
                    </a>
                <div className='dn-search-result-item-type'>{itemType}</div>
                <div className='dn-search-result-item-desc'
                  dangerouslySetInnerHTML={{"__html": this._getDescription(ri)}}></div>
            </div>
        );
    }

    _getName(i) {
      return i.highlight.name && i.highlight.name.length > 0 ? i.highlight.name[0] : i.source.name;
    }
  
    _getDescription(i) {
      const { highlight, source } = i;
  
      // 🩷 For API tab in the future (there is same logic in PubHubSDK).
      // const isAPI = (source.type || '').toLowerCase() == "api";
      // if (isAPI) {
      //   return (this._getDescriptionFromHighLightField(highlight.description)
      //     || this._getDescriptionFromSourceField(source.description)
      //     || this._getDescriptionFromHighLightField(highlight.contentFullText)
      //     || this._getDescriptionFromSourceField(source.contentFullText));
      // }
  
      return (this._getDescriptionFromHighLightField(highlight.contentFullText)
          || this._getDescriptionFromSourceField(source.contentFullText)
          || this._getDescriptionFromHighLightField(highlight.description)
          || this._getDescriptionFromSourceField(source.description));
    }
  
    _getDescriptionFromHighLightField(field) {
      if (!field || !field.length) return '';
  
      const list = [];
      let length = 0;
      for(let i = 0; i < field.length; i++) {
        const item = field[i];
        list.push(item);
        length += item.length;
        if (length >= MAX_LENGTH) {
          break;
        }
      }
  
      return list.join(ELLIPSIS + " ");
    }
  
    _getDescriptionFromSourceField(field) {
      if (!field) return '';
  
      return field.length > MAX_LENGTH ? field.substr(0, MAX_LENGTH) + ELLIPSIS : field;
    }
  

    _generatePagination(type, result, pageNum, pageSize) {
        let total = 0;
        if (!type) {
            total = result.total;
        } else {
            const statByType = result.statSummary?.statByType?.find(i => i.type == type);
            if (statByType) {
                total = statByType.numCandidates;
            }
        }

        if (total <= result.pageSize) {
            return null;
        }

        return (
            <Pagination
                maxButtonCount={this.state.paginationMaxButtonCount}
                pageNum={pageNum}
                total={total}
                pageSize={pageSize}
                onChangeNum={this.props.onChangeNum} />
        );
    }

    render() {
        if (!this.props.searchKey) {
            return (
                <section className='dn-search-result'></section>
            );
        }

        const type = this.props.activedType;
        const items = this.props.result.items.map(this._generateItem);

        const busy = this.props.busy ? this._generateBusyEffect() : null;
        const noContent = this.props.busy ? null : this._generateNoContent();
        const content = items.length != 0 ? items : noContent;
        const className = "dn-search-result" + (this.props.busy ? " dn-search-result-is-busy" : "");

        const pagination = items.length == 0 ? null : this._generatePagination(type, this.props.result, this.props.pageNum, this.props.pageSize);

        return (
            <section className={className}>
                <div className="container">
                    {busy}
                    {content}
                    {pagination}
                </div>
            </section>
        )
    }
}